import React from "react";
import "./zoomImg.css"

const ZoomImg = ({base64,onCloseZoomedImg}) => (
    <div className="zoom-img-container" onClick={()=> onCloseZoomedImg()}>
        <div className="zoom-space" >
            <div className="zoomed-image"  style={{
                backgroundImage: `url(${base64})`
            }}>
                {/*<div className="zoom-close" onClick={()=> onCloseZoomedImg()}>X</div>*/}
            </div>
        </div>
    </div>
)

export default ZoomImg;
